import React, {Component} from 'react';

import {
    TextInput
} from "carbon-components-react";

class Input extends Component {
    state = {
        empty: typeof this.props.value === 'undefined' || this.props.value === ''
    };

    constructor(props) {
        super(props);
        this.textInput = React.createRef();
        this.focusTextInput = this.focusTextInput.bind(this);
    }


    componentWillReceiveProps(nextProps) {
        const {value} = nextProps;
        const {empty} = this.state;

        if (value !== '' && empty) {
            this.setState({empty: false});
        }
    }

    handleChange = e => {
        e.preventDefault();
        this.setState({
            empty: e.target.value === ''
        });

        const {onChange} = this.props;
        return onChange ? onChange(e) : null;
    };

    focusTextInput() {
        // Explicitly focus the text input using the raw DOM API
        // Note: we're accessing "current" to get the DOM node
        this.textInput.current.focus();
    }

    render() {
        const {empty} = this.state;
        const {
            id,
            type,
            min,
            step,
            label,
            onChange,
            inputRef,
            error,
            appendMessage,
            value = '',
            small,
            readOnly,
            ...otherProps
        } = this.props;

        return (
            <TextInput
                pattern="^[0-9]"
                id={id} type={type} min={min} step={step} ref={inputRef} onChange={this.handleChange} value={value}
                readOnly={readOnly} {...otherProps} />
        );
    }
}

export default Input;
